interface CustomsProcedure {
  code: string
  value: string
}

export const RequestedProcedures: CustomsProcedure[] = [
  { code: '01', value: 'releaseForFreeCirculation' },
  { code: '07', value: 'releaseWithWarehousing' },
  { code: '40', value: 'simultaneousReleaseAndHomeUse' },
  { code: '42', value: 'releaseWithVatExemptSupply' },
  { code: '43', value: 'releaseUnderTransitionalMeasures' },
  { code: '44', value: 'endUse' },
  { code: '45', value: 'partialEntryForHomeUse' },
  { code: '46', value: 'importProcessedProducts' },
  { code: '48', value: 'entryForHomeUseWithReplacement' }
]

export const PreviousProcedures: CustomsProcedure[] = [
  { code: '01', value: 'releaseForFreeCirculation' },
  { code: '40', value: 'simultaneousReleaseAndHomeUse' },
  { code: '42', value: 'releaseWithVatExemptSupply' },
  { code: '45', value: 'partialEntryForHomeUse' },
  { code: '51', value: 'inwardProcessing' },
  { code: '54', value: 'temporaryAdmission' }
]
